<template>
  <div class="plk_configuration">
    <i :class="{'notAllowed': disableOptions, 'pointer': !disableOptions}">
      <i @click="showCode=!showCode" v-if="!showCode && !disableOptions" :class="{'disabled' : disableOptions}" class="fas fa-terminal mb-1 mr-1 pointer"></i>
      <i @click="showCode=!showCode" v-if="showCode || disableOptions" :class="{'disabled' : disableOptions}" class="fas fa-laptop-code mb-1 mr-1 pointer"></i>
    </i>
    <form @submit.prevent="save">
      <div v-for="(field, index) in (showCode ? [] : fields)" :key="index">
        <component :global="model" @changeValue="changeValue(field.field, $event)" v-if="getInstance(field.type)" v-bind:is="getInstance(field.type)" :plkparams="field.plkparams" :default="defaultValues[field.field] === undefined ? field.default : defaultValues[field.field]"></component>
      </div>
      <textarea v-if="showCode || !fields.length" v-model="codestr" class="u-full-width" required></textarea>
      <button type="submit" class="mt-2 mb-5 button pull-right">{{$t('configuration.save')}}</button>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { addValueInKey, valueByString } from '@/plugins/object'
import mixindesign from '@/mixins/mixindesign'
import i18n from './i18n'
export default {
  name: 'configuration',
  mixins: [mixindesign],
  props: {
    initValue: {
      type: Object,
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      instances: {},
      defaultValues: {},
      model: {},
      codestr: '',
      showCode: false
    }
  },
  computed: {
    disableOptions () {
      return !this.fields.length
    },
    package () {
      return this.packages[this.type] || {}
    },
    fields () {
      return (this.package.fields || [])
    }
  },
  methods: {
    save () {
      if (this.showCode || this.disableOptions) {
        this.setModel(this.codestr)
      }
      Vue.delete(this.model, 'plkNoEdited')
      this.$emit('changeValue', { model: this.model })
    },
    changeValue (field = '', change = {}) {
      if (field) {
        Vue.set(this, 'model', addValueInKey(Object.assign({}, this.model), field, change.value))
      }
    },
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
      this.refreshModel()
    },
    refreshModel () {
      Vue.set(this, 'model', this.initValue || {})
      this.setCodeStr(this.model)
      Vue.set(this, 'showCode', false)
      this.loadPackage(this.type)
    },
    setCodeStr (model) {
      Vue.set(this, 'codestr', JSON.stringify(model, null, 2))
    },
    setModel (codestr) {
      const model = this.parseModel(codestr)
      if (model) {
        Vue.set(this, 'model', model)
      }
    },
    parseModel (codestr) {
      try {
        return JSON.parse(codestr)
      } catch (e) {}
      return undefined
    },
    getInstance (type = '') {
      return this.instances[this.$servicesPLK.component.normalizeType(type)]
    },
    loadComponentsByTypes () {
      this.fields.forEach(param => {
        this.$servicesPLK.component.loadComponent(param.type, this.instances, this.$servicesPLK.component.normalizeType(param.type))
      })
    },
    addDefaultVars (values) {
      if (values) {
        this.fields.forEach(field => {
          Vue.set(this.defaultValues, field.field, valueByString(values, field.field))
        })
      }
    }
  },
  watch: {
    type () {
      this.loadPackage(this.type)
    },
    package () {
      this.loadComponentsByTypes()
      this.addDefaultVars(this.initValue)
    },
    initValue () {
      this.refreshModel()
    },
    showCode () {
      if (this.showCode) {
        this.setCodeStr(this.model)
      } else {
        const newModel = this.parseModel(this.codestr)
        if (newModel) {
          this.addDefaultVars(newModel)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .u-full-width {
    resize: vertical;
    min-height: 50vh;
  }
  i.disabled {
    color: grey;
    cursor: not-allowed !important;
    pointer-events: none;
  }
</style>
